import Grid2 from "@mui/material/Unstable_Grid2";
import NavigationToggle from "./NavigationToggle";
import BackButton from "./BackButton";

function NavBar() {
    return (
        <div
            style={{
                width: "100%",
                zIndex: 100,
                position: "absolute",
                marginTop: "1rem",
            }}
        >
            <Grid2 container alignItems="center">
                <Grid2 xs={1} xsOffset={1}>
                    <BackButton />
                </Grid2>
                <Grid2 xs={8}>
                    <NavigationToggle />
                </Grid2>
            </Grid2>
        </div>
    );
}

export default NavBar;
